import { useMemo } from "react";
import { useAppSelector } from "../app/hooks";
import { useGetListQuery } from "../features/api/Api";
import { selectCurrentUser } from "../features/auth/AuthSlice";

const useUser = () => {
  const user = useAppSelector<any>(selectCurrentUser);

  /* const { data } = useGetListQuery(
    {
      resource: `setting/ldap/${user?.id}`,
    },
    { skip: !Boolean(user) }
  ); */

  /* const groupId = useMemo(() => {
    if (data?.data) {
      const { ldapGroupLdapUsers }: any = data?.data;

      if (ldapGroupLdapUsers && ldapGroupLdapUsers.length > 0) {
        const mainGroup = ldapGroupLdapUsers.find(
          (item: any) => item.mainGroup === true
        );

        return mainGroup;
      }
      return "";
    }
    return "";
  }, [data]); */

  return useMemo(() => ({ user }), [user]);
};

export default useUser;
